"use client"

import { LOQATE_VERIFY_CLIENT_TIMEOUT_MS } from "@/lib/loqate/constants"
import { type AddressVerificationResult } from "@/types/loqate/verify"

export interface VerifyAddressParams {
    address1: string
    address2?: string
    apartment?: string
    city?: string
    state?: string
    zipCode?: string
    country: string
}

const ACCEPT: AddressVerificationResult = {
    decision: "accept",
    issues: [],
    avc: null,
    verificationUnavailable: true
}

/**
 * Anything other than a usable answer resolves to `accept`, so an outage cannot trap a
 * customer in checkout. The retry lives server-side; retrying here too would send four.
 */
export const verifyAddress = async (
    params: VerifyAddressParams
): Promise<AddressVerificationResult> => {
    try {
        const response = await fetch("/api/loqate/verify", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
            signal: AbortSignal.timeout(LOQATE_VERIFY_CLIENT_TIMEOUT_MS)
        })

        const result = (await response.json()) as AddressVerificationResult

        if (result?.decision === "accept" || result?.decision === "fix") {
            return result
        }

        return ACCEPT
    } catch {
        return ACCEPT
    }
}
